export default __webpack_public_path__ + "static/media/fitness-schedule-2021.a626ba8c.jpg";